import { PoolLink, PoolTypography } from '@synergy/components-next';
import { ReactElement } from 'react';
import { SortingArrowUpIcon } from '@synergy/theme-next';
import { Stack, styled } from '@mui/material';

const Wrapper = styled(Stack)(({ theme }) => ({
    flexDirection: 'row',
    justifyContent: 'flex-end',
    padding: '16px 14px',
    height: 48,
    backgroundColor: theme.palette.grey[900],
}));

export const MobileFooterTop = (): ReactElement => {
    return (
        <Wrapper>
            <PoolLink colorVariant="grey400" onClick={() => window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })}>
                <PoolTypography variant="caption" translationId="app.footer.mobile.top.navigateToTop" />
                <SortingArrowUpIcon />
            </PoolLink>
        </Wrapper>
    );
};
